import { ArrowRight, Star, ShieldCheck, Sparkles } from "lucide-react";
import { ASSETS, COMPANY } from "@/data/site";

export default function Hero() {
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section data-testid="hero-section" className="relative min-h-screen flex items-center overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img src={ASSETS.hero} alt="" className="w-full h-full object-cover opacity-50" />
        <div className="absolute inset-0 bg-gradient-to-r from-ink-900 via-ink-900/85 to-ink-900/30" />
        <div className="absolute inset-0 bg-gradient-to-t from-ink-900 via-transparent to-ink-900/30" />
      </div>

      <div className="relative max-w-7xl mx-auto w-full px-6 md:px-10 lg:px-12 pt-32 pb-24">
        <div className="max-w-2xl">
          <div className="flex items-center gap-3 mb-8">
            <div className="flex gap-1 text-gold">
              {Array.from({ length: 5 }).map((_, i) => (
                <Star key={i} size={14} fill="currentColor" stroke="none" />
              ))}
            </div>
            <span className="text-xs tracking-[0.3em] uppercase text-gold">
              Premium Cleaning · Ludwigshafen · {COMPANY.region}
            </span>
          </div>

          <h1 className="font-display text-5xl sm:text-6xl lg:text-7xl text-white leading-[1.05] tracking-tight animate-fade-up">
            Five Star <br />
            <span className="italic text-gold-soft">Reinigung.</span>
          </h1>

          <p className="mt-8 text-lg md:text-xl text-zinc-300 max-w-xl leading-relaxed">
            Gebäudereinigung, Industriereinigung und Bauendreinigung —
            ausgeführt mit der Sorgfalt und Präzision, die ein Fünf-Sterne-Service verlangt.
          </p>

          <div className="mt-10 flex flex-wrap gap-4">
            <button
              data-testid="hero-cta-primary"
              onClick={() => scrollTo("kontakt")}
              className="group inline-flex items-center gap-2 px-7 py-4 bg-gold text-ink-900 text-sm font-medium uppercase tracking-wider hover:bg-gold-hover transition-all duration-300"
            >
              Kostenfreies Angebot
              <ArrowRight size={16} className="group-hover:translate-x-1 transition-transform" />
            </button>
            <button
              data-testid="hero-cta-secondary"
              onClick={() => scrollTo("leistungen")}
              className="inline-flex items-center gap-2 px-7 py-4 border border-gold/60 text-gold text-sm font-medium uppercase tracking-wider hover:bg-gold/10 transition-all duration-300"
            >
              Leistungen entdecken
            </button>
          </div>

          <div className="mt-16 grid grid-cols-1 sm:grid-cols-3 gap-6 max-w-2xl">
            <div className="flex items-start gap-3">
              <ShieldCheck size={20} className="text-gold mt-0.5 flex-shrink-0" />
              <span className="text-sm text-zinc-300">Versichert & zertifiziert</span>
            </div>
            <div className="flex items-start gap-3">
              <Sparkles size={20} className="text-gold mt-0.5 flex-shrink-0" />
              <span className="text-sm text-zinc-300">Sorgfältig geprüfte Verfahren</span>
            </div>
            <div className="flex items-start gap-3">
              <Star size={20} className="text-gold mt-0.5 flex-shrink-0" fill="currentColor" />
              <span className="text-sm text-zinc-300">Fünf-Sterne-Anspruch</span>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 text-zinc-500">
        <span className="text-[10px] tracking-[0.4em] uppercase">Scroll</span>
        <div className="w-px h-12 bg-gradient-to-b from-gold to-transparent" />
      </div>
    </section>
  );
}
